import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  async created() {
    axios.defaults.withCredentials = true
    axios.interceptors.response.use(
      response => response,
      error => {
        console.log(error)
        if (
          error.response.status === 401 ||
          error.response.status === 422 ||
          error.response.status === 500
        ) {
          if (
            error.response.data.errors.error ===
            'username or password is invalid'
          ) {
            store.commit('setLoginError', error.response.data.errors.error)
          } else {
            if (this.$router.history.current.path !== '/sorn') {
              this.$store.dispatch('logoffUser')
              //localStorage.removeItem('sornAccepted')
              // test
              this.$router.push('/sorn')
            }
          }
        }
        return Promise.reject(error)
      },
    )
  },
  render: h => h(App),
}).$mount('#app')
